const template = {
    name: "Default NEC3 ECSC v4.2 16/07/2025",
    isSystemDefault: true,
    isGlobal: true,
    companies: [],
    resources: [
        {
            id: 1,
            type: "TEXT",
            key: "SUPPLIER_NAME",
            value: "Contractor"
        },
        {
            id: 2,
            type: "TEXT",
            key: "SUPPLIER_ABBREVIATION",
            value: "CON"
        },
        {
            id: 3,
            type: "TEXT",
            key: "PM_NAME",
            value: "Employer"
        },
        {
            id: 4,
            type: "TEXT",
            key: "PM_ABBREVIATION",
            value: "EMP"
        },
        {
            id: 5,
            type: "TEXT",
            key: "SUPERVISOR_NAME",
            value: "Contractor (Supervisor)"
        },
        {
            id: 6,
            type: "TEXT",
            key: "SUPERVISOR_ABBREVIATION",
            value: "SUP"
        },
        {
            id: 7,
            type: "TEXT",
            key: "CLIENT_NAME",
            value: "Employer"
        },
        {
            id: 8,
            type: "NUMBER",
            key: "SUPPLIER_REPLY_PERIOD",
            value: 7
        },
        {
            id: 9,
            type: "NUMBER",
            key: "PM_REPLY_PERIOD",
            value: 7
        },
        {
            id: 10,
            type: "NUMBER",
            key: "QUOTE_DURATION",
            value: 14
        },
        {
            id: 13,
            type: "NUMBER",
            key: "REQUOTE_DURATION",
            value: 14
        },
        {
            id: 11,
            type: "NUMBER",
            key: "QUOTE_RESPONSE",
            value: 7
        },
        {
            id: 14,
            type: "NUMBER",
            key: "REQUOTE_RESPONSE",
            value: 7
        },
        {
            id: 12,
            type: "NUMBER",
            key: "VARIATION_RESPONSE",
            value: 7
        },
        {
            id: 15,
            type: "NUMBER",
            key: "PAYMENT_PERIOD",
            value: 21
        },
        {
            id: 17,
            type: "NUMBER",
            key: "QUOTE_DURATION_PRIOR_REPLY",
            value: 14
        }
    ],
    workflowGroups: [
        {
            id: 101,
            title: "Early Warnings",
            workflows: [
                {
                    id: 1,
                    title: "$PM_NAME Early Warnings",
                    notificationName: "Early Warning",
                    abbreviation: "$PM_ABBREVIATION-Warning-",
                    notify: true,
                    replyEnabled: true,
                    assetFieldsEnabled: false,
                    replyPeriodOption: "SUPPLIER_REPLY_PERIOD",
                    replyPeriod: 0,
                    notifyingParty: "PM",
                    replyingParty: "SUPPLIER",
                    actioningParty: "PM",
                    resolveActioningParty: "PM",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    replyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
                            communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        replyNotice: {
                            saveDraftReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            communicateReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]"
                        },
                        actionTab: {
                            actionFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]",
                        resolveActionTab: {
                            resolveActionFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]"
                        }
                    }
                },
                {
                    id: 2,
                    title: "$SUPPLIER_NAME Early Warnings",
                    notificationName: "Early Warning",
                    abbreviation: "$SUPPLIER_ABBREVIATION-Warning-",
                    notify: true,
                    replyEnabled: true,
                    assetFieldsEnabled: false,
                    replyPeriodOption: "PM_REPLY_PERIOD",
                    replyPeriod: 0,
                    notifyingParty: "SUPPLIER",
                    replyingParty: "PM",
                    actioningParty: "PM",
                    resolveActioningParty: "PM",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    replyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
                            communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        replyNotice: {
                            saveDraftReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            communicateReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]"
                        },
                        actionTab: {
                            actionFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]",
                        resolveActionTab: {
                            resolveActionFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]"
                        }
                    }
                },
                {
                    id: 3,
                    title: "Risk Register",
                    notificationName: "Early Warning",
                    abbreviation: "Warning",
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null"
                    }
                }
            ],
            placeholders: [
                {
                    replacementKey: "Resources",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "MeetingRequiredLabel",
                            display: "Is a risk reduction meeting required?",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "NotificationClause",
                            display: "You are given early warning of a matter which could",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "RiskItemsLabel",
                            display: "You are given early warning of a matter which could",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "RiskTypes",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "riskincreaseprice",
                            display: "increase the total of the Prices",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "riskdelaycompletion",
                            display: "delay Completion",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "riskimpairperformance",
                            display: "impair the performance of the works in use",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "RiskTypesSupplier",
                    values: [
                        {
                            id: 2,
                            isActive: true,
                            field: "riskincreaseprice",
                            display: "increase the total of the Prices",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "riskdelaycompletion",
                            display: "delay Completion",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "riskimpairperformance",
                            display: "impair the performance of the works in use",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: true,
                            field: "riskincreasecontractorcost",
                            display: "increase the $SUPPLIER_NAME's cost",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "MeetingOptions",
                    values: [
                        {
                            id: 1,
                            isActive: false,
                            field: "0",
                            display: "Extra meeting not required",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "1",
                            display: "To be discussed at the next scheduled risk reduction meeting",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "2",
                            display: "Propose risk reduction meeting",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "ActionReminders",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "Pm",
                            display: "$WF_1_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "Supplier",
                            display: "$WF_2_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "Client",
                            display: "$WF_74_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "RiskStatusOptions",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "Mitigated",
                            display: "Mitigated",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "NotMitigated",
                            display: "Not mitigated",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                }
            ]
        },
        {
            id: 102,
            title: "Instructions",
            workflows: [
                {
                    id: 4,
                    title: "$PM_NAME Instruction",
                    notificationName: "Instruction",
                    abbreviation: "$PM_ABBREVIATION-Instruction-",
                    notify: true,
                    replyEnabled: false,
                    assetFieldsEnabled: false,
                    replyPeriodOption: "SUPPLIER_REPLY_PERIOD",
                    replyPeriod: 0,
                    resubmitPeriodOption: "PM_REPLY_PERIOD",
                    resubmitPeriod: 0,
                    notifyingParty: "PM",
                    replyingParty: "SUPPLIER",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    replyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
                            communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        replyNotice: {
                            saveDraftReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            communicateReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]"
                    }
                }
            ],
            placeholders: [
                {
                    replacementKey: "InstructionTypes",
                    values: [
                        {
                            id: 2,
                            isActive: true,
                            field: "",
                            display: "14.2 to change the Works Information",
                            overrideResources: null,
                            postActions: [
                                {
                                    askUser: true,
                                    daysForAction: 0,
                                    action: "CREATE",
                                    ownerParty: "PM",
                                    actionType: "WF_5",
                                    timePeriod: "CUSTOM"
                                }
                            ]
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "",
                            display: "21.3 to remove an employee",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "",
                            display: "30.4 to stop or not start work",
                            overrideResources: null,
                            postActions: [
                                {
                                    askUser: true,
                                    daysForAction: 0,
                                    action: "CREATE",
                                    ownerParty: "PM",
                                    actionType: "WF_5",
                                    timePeriod: "CUSTOM"
                                }
                            ]
                        },
                        {
                            id: 9,
                            isActive: true,
                            field: "",
                            display: "30.4. to start or restart work",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: true,
                            field: "",
                            display: "43.1 to not replace or repair damage to the works, Plant and Materials",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: true,
                            field: "",
                            display: "62.2 to submit alternative quotations",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: true,
                            field: "",
                            display: "70.1 on how to deal with an object of value or historical interest",
                            overrideResources: null,
                            postActions: [
                                {
                                    askUser: true,
                                    daysForAction: 0,
                                    action: "CREATE",
                                    ownerParty: "PM",
                                    actionType: "WF_5",
                                    timePeriod: "CUSTOM"
                                }
                            ]
                        },
                        {
                            id: 8,
                            isActive: true,
                            field: "",
                            display: "Other instruction",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "ActionReminders",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "PM",
                            display: "$WF_4_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "Supervisor",
                            display: "$WF_61_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "Client",
                            display: "$WF_56_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                }
            ]
        },
        {
            id: 103,
            title: "Compensation Events",
            workflows: [
                {
                    id: 5,
                    title: "$PM_NAME Compensation Events",
                    notificationName: "Compensation Event",
                    abbreviation: "$PM_ABBREVIATION-Compensation-",
                    notify: true,
                    financialLimitEnabled: false,
                    assetFieldsEnabled: false,
                    notifyingParty: "PM",
                    quotingParty: "SUPPLIER",
                    quoteReplyingParty: "PM",
                    quoteNotificationName: "Quote",
                    quoteReferencePrefix: "Quote-",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
                            communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        quoteMainNotice: {
                            createQuoteFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            communicateQuoteFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        quoteReplyNotice: {
                            saveQuoteDraftReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            communicateQuoteReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]"
                    }
                },
                {
                    id: 40,
                    title: "$SUPPLIER_NAME Compensation Events",
                    notificationName: "Compensation Event",
                    abbreviation: "$SUPPLIER_ABBREVIATION-Compensation-",
                    notify: true,
                    replyEnabled: true,
                    financialLimitEnabled: false,
                    assetFieldsEnabled: false,
                    replyPeriodOption: "VARIATION_RESPONSE",
                    replyPeriod: 0,
                    notifyingParty: "SUPPLIER",
                    replyingParty: "PM",
                    quotingParty: "SUPPLIER",
                    quoteReplyingParty: "PM",
                    quoteNotificationName: "Quote",
                    quoteReferencePrefix: "Quote-",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    replyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
                            communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        replyNotice: {
                            saveDraftReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Support\"],\"or\",[\"rolepermissions\",\"=\",\"Manager\"]]]",
                            communicateReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]"
                        },
                        quoteMainNotice: {
                            createQuoteFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            communicateQuoteFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        quoteReplyNotice: {
                            saveQuoteDraftReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            communicateQuoteReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Supervisor\"],\"or\",[\"party\",\"=\",\"Client\"]]"
                    }
                },
                {
                    id: 6,
                    title: "$PM_NAME Proposed Instructions",
                    notificationName: "Proposed Instruction",
                    abbreviation: "$PM_ABBREVIATION-PROP-",
                    notify: true,
                    financialLimitEnabled: false,
                    assetFieldsEnabled: false,
                    notifyingParty: "PM",
                    quotingParty: "SUPPLIER",
                    quoteReplyingParty: "PM",
                    quoteNotificationName: "Quote",
                    quoteReferencePrefix: "Quote-",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
                            communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        quoteMainNotice: {
                            createQuoteFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            communicateQuoteFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        quoteReplyNotice: {
                            saveQuoteDraftReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            communicateQuoteReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]"
                    }
                },
                {
                    id: 8,
                    title: "$PM_NAME CE Assessments",
                    notificationName: "Assessment of Compensation Event",
                    abbreviation: "$PM_ABBREVIATION-CE-Assessment-",
                    notify: true,
                    financialLimitEnabled: false,
                    assetFieldsEnabled: false,
                    notifyingParty: "PM",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
                            communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Supervisor\"],\"or\",[\"party\",\"=\",\"Client\"]]"
                    }
                },
                {
                    id: 11,
                    title: "Master Quote Register",
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null"
                    }
                },
                {
                    id: 12,
                    title: "Master CE Register",
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null"
                    }
                },
                {
                    id: 13,
                    title: "Implemented CE Register",
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null"
                    }
                }
            ],
            placeholders: [
                {
                    replacementKey: "Resources",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "PmAssumptionLabel",
                            display: "The quotation is to be based on the following assumptions",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "PmAssumptionNote",
                            display: "You are notified of the following event as a compensation event",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "SupplierDescNote",
                            display: "You are notified of the following event as a compensation event",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "ReplyAcceptedCommentLabel",
                            display: "You are notified of the $PM_NAME's decision that the event notified is a compensation event",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: true,
                            field: "ReplyRejectedCommentLabel",
                            display: "Details",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: true,
                            field: "ReplyAcceptedAssumptionLabel",
                            display: "The quotation is to be based on the following assumptions",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: true,
                            field: "QuoteNote",
                            display: "We submit our quotation for compensation event $reference",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 8,
                            isActive: true,
                            field: "ExtensionPMLabel",
                            display: "We require an extension to the contractual time to produce a compensation event quotation response as detailed below for the following reasons",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 9,
                            isActive: true,
                            field: "ExtensionSupplierLabel",
                            display: "We require an extension to the contractual time to produce a compensation event quotation as detailed below for the following reasons",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 10,
                            isActive: true,
                            field: "AssessmentDetailLabel",
                            display: "Details",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 11,
                            isActive: true,
                            field: "ProposedInstructionNote",
                            display: "You are instructed to provide a quotation by $date.",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 12,
                            isActive: true,
                            field: "ProposedInstructionLabel",
                            display: "The quotation is to be based on the following assumptions",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 13,
                            isActive: true,
                            field: "ReplyRejectedOptionsLabel",
                            display: "You are notified of the $PM_NAME's decision that the event notified is not a compensation event as it",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 14,
                            isActive: true,
                            field: "QuoteCostEffectLabel",
                            display: "Change to the Prices",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 15,
                            isActive: true,
                            field: "QuoteDateEffectLabel",
                            display: "Delay to the Completion Date",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 16,
                            isActive: true,
                            field: "QuoteDaysEffectLabel",
                            display: "The length of time that the Completion Date is delayed",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 17,
                            isActive: true,
                            field: "ReplyAcceptedAssumptionNote",
                            display: "You are instructed to submit a quotation by $date",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "CompensationClauses",
                    values: [
                        {
                            id: 2,
                            isActive: true,
                            field: "",
                            display: "60.1(1) An instruction to change the Works Information",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "",
                            display: "60.1(2) $PM_NAME does not allow access to the Site",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "",
                            display: "60.1(3) $PM_NAME does not provide something that he is to provide",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: true,
                            field: "",
                            display: "60.1(4) An instruction to stop or not to start work",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: true,
                            field: "",
                            display: "60.1(5) $PM_NAME does not work within the required constraints",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: true,
                            field: "",
                            display: "60.1(6) $PM_NAME does not reply to a communication",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 8,
                            isActive: true,
                            field: "",
                            display: "60.1(7) A change of decision",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 9,
                            isActive: true,
                            field: "",
                            display: "60.1(8) An instruction to search for a Defect and no Defect is found",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 10,
                            isActive: true,
                            field: "",
                            display: "60.1(9) Physical conditions encountered",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 11,
                            isActive: true,
                            field: "",
                            display: "60.1(10) Weather conditions encountered",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 12,
                            isActive: true,
                            field: "",
                            display: "60.1(11) A notification of a correction to an assumption stated about a compensation event",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 13,
                            isActive: true,
                            field: "",
                            display: "60.1(12) A prevention event occurs",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 14,
                            isActive: true,
                            field: "",
                            display: "60.1(13) A difference in quantities",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 15,
                            isActive: true,
                            field: "",
                            display: "60.1(14) Loss or damage to the subcontract works",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 16,
                            isActive: true,
                            field: "",
                            display: "1.4 Suspension of performance",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "ReplyRejectOptions",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "faultpscp",
                            display: "arises from a fault of the $SUPPLIER_NAME",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "notexpectnothappen",
                            display: "has not happened and is not expected to happen",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "noteffectcostcompletion",
                            display: "has no effect upon the Defined Cost or upon Completion",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "statedcontract",
                            display: "is not one of the compensation events stated in this subcontract",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "InstructionReplyProceedOpts",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "61.1",
                            display: "61.1 Consultant is instructed to proceed with works",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "61.2",
                            display: "61.2 Consultant is instructed to NOT proceed with works until instructed",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "QuoteStatuses",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "0",
                            display: "Not Accepted - $SUPPLIER_NAME to resubmit",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "1",
                            display: "Accepted",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "2",
                            display: "Awaiting Response",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "3",
                            display: "Not Accepted - $PM_ABBREVIATION to make assessment",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: true,
                            field: "4",
                            display: "Not Accepted - Other quote approved",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: true,
                            field: "5",
                            display: "Not Accepted - Proposed instruction will not be given",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: true,
                            field: "6",
                            display: "Awaiting Deemed Acceptance",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 8,
                            isActive: true,
                            field: "7",
                            display: "Deemed Accepted",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 9,
                            isActive: true,
                            field: "none",
                            display: "Not Communicated",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 10,
                            isActive: true,
                            field: "8",
                            display: "Acknowledged",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 11,
                            isActive: true,
                            field: "9",
                            display: "Not Accepted - Process ended",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 12,
                            isActive: true,
                            field: "10",
                            display: "Assessed",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "CompensationStatuses",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "APMA",
                            display: "Quote Not Accepted - $PM_ABBREVIATION to make own Assessment",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "ARQ",
                            display: "Quote Not Accepted - $SUPPLIER_NAME to resubmit",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "AM",
                            display: "$PM_ABBREVIATION Assessment Made",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "QA",
                            display: "Quote Accepted",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: true,
                            field: "APMRQ",
                            display: "Awaiting $PM_ABBREVIATION Response to quote",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: true,
                            field: "APMR",
                            display: "Awaiting $PM_ABBREVIATION Response to CEN",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: true,
                            field: "AQ",
                            display: "Awaiting Quote",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 8,
                            isActive: true,
                            field: "NC",
                            display: "Not Communicated",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 9,
                            isActive: true,
                            field: "R",
                            display: "Not a Compensation Event",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 10,
                            isActive: true,
                            field: "DNG",
                            display: "Proposed instruction will not be given",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 11,
                            isActive: true,
                            field: "ADAQ",
                            display: "Awaiting Deemed Acceptance of Quote",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 12,
                            isActive: true,
                            field: "DA",
                            display: "Deemed Accepted",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "RelatedCompensationText",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "RelatedCompensationText",
                            display: "Regarding the aforementioned instruction, you are hereby notified of a compensation event under clause 61.1",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "ActionReminders",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "PmCompensationAQ",
                            display: "$WF_5_TITLE awaiting quotation",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "PmCompensationARQ",
                            display: "$WF_5_TITLE awaiting revised quotation",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "PmCompensationAPMRQ",
                            display: "$WF_5_TITLE awaiting reply to quotation",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "PmCompensationAPMA",
                            display: "$WF_5_TITLE awaiting assessment",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: true,
                            field: "SupCompensationAQ",
                            display: "$WF_7_TITLE awaiting quotation",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: true,
                            field: "SupCompensationARQ",
                            display: "$WF_7_TITLE awaiting revised quotation",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: true,
                            field: "SupCompensationAPMR",
                            display: "$WF_7_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 8,
                            isActive: true,
                            field: "SupCompensationAPMRQ",
                            display: "$WF_7_TITLE awaiting reply to quotation",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 9,
                            isActive: true,
                            field: "SupCompensationAPMA",
                            display: "$WF_7_TITLE awaiting assessment",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 10,
                            isActive: true,
                            field: "PmProposedAQ",
                            display: "$WF_6_TITLE awaiting quotation",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 11,
                            isActive: true,
                            field: "PmProposedARQ",
                            display: "$WF_6_TITLE awaiting revised quotation",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 12,
                            isActive: true,
                            field: "PmProposedAPMRQ",
                            display: "$WF_6_TITLE awaiting reply to quotation",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 13,
                            isActive: true,
                            field: "PmProposedAPMA",
                            display: "$WF_6_TITLE awaiting assessment",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 15,
                            isActive: true,
                            field: "SupAssumption",
                            display: "$WF_42_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 21,
                            isActive: true,
                            field: "SupClaimAPMR",
                            display: "$WF_37_TITLE awaiting reply to notice",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 16,
                            isActive: true,
                            field: "SupClaimAQ",
                            display: "$WF_37_TITLE awaiting quotation",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 17,
                            isActive: true,
                            field: "SupClaimARQ",
                            display: "$WF_37_TITLE awaiting revised quotation",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 19,
                            isActive: true,
                            field: "SupClaimAPMRQ",
                            display: "$WF_37_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 20,
                            isActive: true,
                            field: "SupClaimAPMA",
                            display: "$WF_37_TITLE awaiting determination",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 22,
                            isActive: true,
                            field: "replydraftpmcequotessupplier",
                            display: "$WF_7_TITLE quotations",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 25,
                            isActive: true,
                            field: "COMPENSATION_CWN_APMR",
                            display: "$WF_67_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 23,
                            isActive: true,
                            field: "COMPENSATION_CWN_AQ",
                            display: "$WF_67_TITLE awaiting reply awaiting full details",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 24,
                            isActive: true,
                            field: "COMPENSATION_CWN_ARQ",
                            display: "$WF_67_TITLE awaiting reply awaiting revised details",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 26,
                            isActive: true,
                            field: "COMPENSATION_CWN_APMRQ",
                            display: "$WF_67_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 27,
                            isActive: true,
                            field: "COMPENSATION_CWN_APMA",
                            display: "$WF_67_TITLE awaiting determination",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 28,
                            isActive: true,
                            field: "COMPENSATION_CLIENTCWN_AQ",
                            display: "$WF_75_TITLE awaiting full details",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 29,
                            isActive: true,
                            field: "COMPENSATION_CLIENTCWN_ARQ",
                            display: "$WF_75_TITLE awaiting revised details",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 30,
                            isActive: true,
                            field: "COMPENSATION_CLIENTCWN_APMR",
                            display: "$WF_75_TITLE awaiting reply to notice",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 31,
                            isActive: true,
                            field: "COMPENSATION_CLIENTCWN_APMRQ",
                            display: "$WF_75_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 32,
                            isActive: true,
                            field: "COMPENSATION_CLIENTCWN_APMA",
                            display: "$WF_75_TITLE awaiting determination",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 33,
                            isActive: true,
                            field: "COMPENSATION_CLIENT_AQ",
                            display: "$WF_76_TITLE awaiting quotation",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 34,
                            isActive: true,
                            field: "COMPENSATION_CLIENT_ARQ",
                            display: "$WF_76_TITLE awaiting revised quotation",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 35,
                            isActive: true,
                            field: "COMPENSATION_CLIENT_APMR",
                            display: "$WF_76_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 36,
                            isActive: true,
                            field: "COMPENSATION_CLIENT_APMRQ",
                            display: "$WF_76_TITLE awaiting reply to quotation",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 37,
                            isActive: true,
                            field: "COMPENSATION_CLIENT_APMA",
                            display: "$WF_76_TITLE awaiting assessment",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 14,
                            isActive: true,
                            field: "PmExtension",
                            display: "$WF_9_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 38,
                            isActive: true,
                            field: "SupExtension",
                            display: "$WF_10_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "CompensationEventsAcceptanceOptions",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "1",
                            display: "Is a compensation event",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "0",
                            display: "Is not a compensation event",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                }
            ]
        },
        {
            id: 104,
            title: "Programme",
            workflows: [
                {
                    id: 14,
                    title: "$SUPPLIER_NAME Programme",
                    notificationName: "Programme",
                    abbreviation: "$SUPPLIER_ABBREVIATION-Programme-",
                    notify: true,
                    replyEnabled: true,
                    assetFieldsEnabled: false,
                    replyPeriodOption: "PROGRAMME_REPLY_PERIOD",
                    replyPeriod: 0,
                    resubmitPeriodOption: "SUPPLIER_REPLY_PERIOD",
                    resubmitPeriod: 0,
                    notifyingParty: "SUPPLIER",
                    replyingParty: "PM",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    replyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
                            communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        replyNotice: {
                            saveDraftReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            communicateReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]"
                    }
                }
            ],
            placeholders: [
                {
                    replacementKey: "Resources",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "ReasonLabel",
                            display: "Reason for any change to Planned Completion",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "ChangeLabel",
                            display: "Change in any other Key Date, Completion Date for a section or other important project milestone in period and reasons why",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "MainProgressLabel",
                            display: "Main progress achieved in period",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "KeyActivitiesLabel",
                            display: "Key activities forecast in next four weeks",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: true,
                            field: "SummaryLabel",
                            display: "Summary of critical path",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: true,
                            field: "ChangesLabel",
                            display: "Main changes made to programme in period, e.g. items deleted, new sections or activities added etc.",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: true,
                            field: "CompensationLabel",
                            display: "Compensation events added to programme this period",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 8,
                            isActive: true,
                            field: "NotificationClause",
                            display: "Please find attached programme for acceptance",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 9,
                            isActive: true,
                            field: "ReplyRejectReasonLabel",
                            display: "The $SUPPLIER_NAME’s programme is not accepted for the following reasons",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 10,
                            isActive: true,
                            field: "ReplyNotificationClause",
                            display: "You are notified that the $SUPPLIER_NAME’s Programme",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 11,
                            isActive: true,
                            field: "DashboardPlannedCompletionLabel",
                            display: "Latest Forecast Completion Date",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "ReplyRejectOptions",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "plansnotpractical",
                            display: "The $SUPPLIER_NAME’s plans which it shows are not practicable",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "missingcontractrequires",
                            display: "It does not show the information which this contract requires",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "notrepresentplan",
                            display: "It does not represent the $SUPPLIER_NAME’s plans realistically",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "notcomply",
                            display: "It does not comply with Works Information",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "Fields",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "PreviousPlanned",
                            display: "Previous Planned Completion",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "PlannedCompletion",
                            display: "Forecast date of Completion",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "Reason",
                            display: "Comments on programme update",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: false,
                            field: "Change",
                            display: "Change in any other Key Date, Sectional Completion or other important project milestone in period and reasons why",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: false,
                            field: "MainProgress",
                            display: "Main progress achieved in period",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: false,
                            field: "KeyActivities",
                            display: "Key activities forecast in next four weeks",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: false,
                            field: "Summary",
                            display: "Summary of critical path",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 8,
                            isActive: false,
                            field: "Changes",
                            display: "Main changes made to programme in period, e.g. items deleted, new sections or activities added etc.",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 9,
                            isActive: false,
                            field: "Compensation",
                            display: "Compensation events added to programme this period",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "UnifiedReplyOptions",
                    values: [
                        {
                            id: 1,
                            wfid: 14,
                            isActive: true,
                            field: "ACCEPT",
                            display: "Accepted",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            wfid: 14,
                            isActive: false,
                            field: "ACCEPT_WITH_COMMENTS",
                            display: "Accepted with comments",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            wfid: 14,
                            isActive: true,
                            field: "NOT_ACCEPTED",
                            display: "Not accepted",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            wfid: 14,
                            isActive: true,
                            field: "NOT_ACCEPTED_RESUBMIT",
                            display: "Not accepted - resubmission required",
                            overrideResources: null,
                            postActions: [
                                {
                                    askUser: false,
                                    daysForAction: 0,
                                    action: "CREATE",
                                    ownerParty: "SUPPLIER",
                                    actionType: "WF_14",
                                    timePeriod: "SUPPLIER_REPLY_PERIOD"
                                }
                            ]
                        },
                        {
                            id: 5,
                            wfid: 14,
                            isActive: false,
                            field: "NO_REPLY_REQUIRED",
                            display: "Reply not required",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "ActionReminders",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "Supplier",
                            display: "$WF_14_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                }
            ]
        },
        {
            id: 105,
            title: "Notifications",
            workflows: [
                {
                    id: 15,
                    title: "$PM_NAME Notifications",
                    notificationName: "Notification",
                    abbreviation: "$PM_ABBREVIATION-Notification-",
                    notify: true,
                    replyEnabled: false,
                    assetFieldsEnabled: false,
                    replyPeriodOption: "SUPPLIER_REPLY_PERIOD",
                    replyPeriod: 0,
                    resubmitPeriodOption: "PM_REPLY_PERIOD",
                    resubmitPeriod: 0,
                    notifyingParty: "PM",
                    replyingParty: "SUPPLIER",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    replyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
                            communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        replyNotice: {
                            saveDraftReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            communicateReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]"
                    }
                },
                {
                    id: 16,
                    title: "$SUPPLIER_NAME Notifications",
                    notificationName: "Notification",
                    abbreviation: "$SUPPLIER_ABBREVIATION-Notification-",
                    notify: true,
                    replyEnabled: false,
                    assetFieldsEnabled: false,
                    replyPeriodOption: "PM_REPLY_PERIOD",
                    replyPeriod: 0,
                    resubmitPeriodOption: "SUPPLIER_REPLY_PERIOD",
                    resubmitPeriod: 0,
                    notifyingParty: "SUPPLIER",
                    replyingParty: "PM",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    replyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
                            communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        replyNotice: {
                            saveDraftReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            communicateReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]"
                    }
                }
            ],
            placeholders: [
                {
                    replacementKey: "PmClauses",
                    values: [
                        {
                            id: 2,
                            isActive: true,
                            field: "",
                            display: "13.1 of a change of address for communications",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "",
                            display: "22.1 of access required for others",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: false,
                            field: "",
                            display: "30.3 of certification of Completion",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: true,
                            field: "",
                            display: "42.2 of the cost of correcting an uncorrected Defect",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: true,
                            field: "",
                            display: "61.1 than an assumption on which a compensation event quotation is based was wrong",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: true,
                            field: "",
                            display: "62.2 that the $SUPPLIER_NAME did not give early warning",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 8,
                            isActive: false,
                            field: "",
                            display: "90.1 of a termination certificate",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 9,
                            isActive: true,
                            field: "",
                            display: "90.1 of a wish to terminate the $SUPPLIER_NAME's obligation to Provide the Works",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 10,
                            isActive: true,
                            field: "",
                            display: "90.3 of a default by the $SUPPLIER_NAME",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 11,
                            isActive: true,
                            field: "",
                            display: "Other notification",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "SupplierClauses",
                    values: [
                        {
                            id: 2,
                            isActive: true,
                            field: "",
                            display: "13.1 of a change of address for communications",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "",
                            display: "90.1 of a wish to terminate the $SUPPLIER_NAME's obligation to Provide the Works",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "",
                            display: "Other notification",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "ActionReminders",
                    values: [
                        {
                            id: 4,
                            isActive: true,
                            field: "Client",
                            display: "$WF_57_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "PM",
                            display: "$WF_15_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "Supervisor",
                            display: "$WF_16_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 1,
                            isActive: true,
                            field: "Supplier",
                            display: "$WF_17_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: true,
                            field: "PmToSupervisor",
                            display: "$WF_58_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: true,
                            field: "PmToClient",
                            display: "$WF_59_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 12,
                            isActive: true,
                            field: "SupplierToSupervisor",
                            display: "$WF_81_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: true,
                            field: "SupervisorToPm",
                            display: "$WF_60_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 9,
                            isActive: true,
                            field: "ClientToClient",
                            display: "$WF_64_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 8,
                            isActive: true,
                            field: "PmToPm",
                            display: "$WF_63_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 10,
                            isActive: true,
                            field: "SupplierToSupplier",
                            display: "$WF_65_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 11,
                            isActive: true,
                            field: "SupervisorToSupervisor",
                            display: "$WF_66_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                }
            ]
        },
        {
            id: 106,
            title: "Submissions",
            workflows: [
                {
                    id: 18,
                    title: "$SUPPLIER_NAME Submissions",
                    notificationName: "Submission",
                    abbreviation: "$SUPPLIER_ABBREVIATION-Submission-",
                    notify: true,
                    replyEnabled: true,
                    assetFieldsEnabled: false,
                    replyPeriodOption: "PM_REPLY_PERIOD",
                    replyPeriod: 0,
                    resubmitPeriodOption: "SUPPLIER_REPLY_PERIOD",
                    resubmitPeriod: 0,
                    notifyingParty: "SUPPLIER",
                    replyingParty: "PM",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    replyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
                            communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        replyNotice: {
                            saveDraftReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Support\"],\"or\",[\"rolepermissions\",\"=\",\"Manager\"]]]",
                            communicateReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]"
                    }
                }
            ],
            placeholders: [
                {
                    replacementKey: "Resources",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "ReplyWarningBanner",
                            display: "",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "IssueClauses",
                    values: [
                        {
                            id: 2,
                            isActive: true,
                            field: "",
                            display: "20.1 of particulars of a design",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "",
                            display: "30.2 of a forecast of the date of Completion",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "UnifiedReplyOptions",
                    values: [
                        {
                            id: 1,
                            wfid: 18,
                            isActive: true,
                            field: "ACCEPT",
                            display: "Accepted",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            wfid: 18,
                            isActive: false,
                            field: "ACCEPT_WITH_COMMENTS",
                            display: "Accepted with comments",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            wfid: 18,
                            isActive: true,
                            field: "NOT_ACCEPTED",
                            display: "Not accepted",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            wfid: 18,
                            isActive: true,
                            field: "NOT_ACCEPTED_RESUBMIT",
                            display: "Not accepted - resubmission required",
                            overrideResources: null,
                            postActions: [
                                {
                                    askUser: false,
                                    daysForAction: 0,
                                    action: "CREATE",
                                    ownerParty: "SUPPLIER",
                                    actionType: "WF_18",
                                    timePeriod: "SUPPLIER_REPLY_PERIOD"
                                }
                            ]
                        },
                        {
                            id: 5,
                            wfid: 18,
                            isActive: false,
                            field: "NO_REPLY_REQUIRED",
                            display: "Reply not required",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            wfid: 49,
                            isActive: true,
                            field: "ACCEPT",
                            display: "Accepted",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            wfid: 49,
                            isActive: false,
                            field: "ACCEPT_WITH_COMMENTS",
                            display: "Accepted with comments",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 8,
                            wfid: 49,
                            isActive: true,
                            field: "NOT_ACCEPTED",
                            display: "Not accepted",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 9,
                            wfid: 49,
                            isActive: true,
                            field: "NOT_ACCEPTED_RESUBMIT",
                            display: "Not accepted - resubmission required",
                            overrideResources: null,
                            postActions: [
                                {
                                    askUser: false,
                                    daysForAction: 0,
                                    action: "CREATE",
                                    ownerParty: "PM",
                                    actionType: "WF_49",
                                    timePeriod: "PM_REPLY_PERIOD"
                                }
                            ]
                        },
                        {
                            id: 10,
                            wfid: 49,
                            isActive: false,
                            field: "NO_REPLY_REQUIRED",
                            display: "Reply not required",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "ActionReminders",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "Supplier",
                            display: "$WF_18_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "PM",
                            display: "$WF_49_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                }
            ]
        },
        {
            id: 108,
            title: "Payments",
            workflows: [
                {
                    id: 20,
                    title: "$PM_NAME Assessment",
                    notificationName: "Amount Due Notification",
                    abbreviation: "$PM_ABBREVIATION-AmountDue-",
                    notify: true,
                    financialLimitEnabled: false,
                    assetFieldsEnabled: false,
                    notifyingParty: "PM",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
                            communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]"
                    }
                },
                {
                    id: 21,
                    title: "$SUPPLIER_NAME Payment Applications",
                    notificationName: "Payment Application",
                    abbreviation: "$SUPPLIER_ABBREVIATION-Payment-",
                    notify: true,
                    financialLimitEnabled: false,
                    assetFieldsEnabled: false,
                    notifyingParty: "SUPPLIER",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
                            communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]"
                    }
                }
            ],
            placeholders: [
                {
                    replacementKey: "Resources",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "CumulativePriceLabel",
                            display: "Price for Work Done to Date",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "PlusAmountsSupplierLabel",
                            display: "Plus other amounts to be paid to the $SUPPLIER_NAME",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "LessAmountsSupplierLabel",
                            display: "Less amounts to be paid by or retained from the $SUPPLIER_NAME",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "TaxSupplierLabel",
                            display: "Tax which the law requires the Employer to pay to the $SUPPLIER_NAME",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: true,
                            field: "RegisterCertifiedDateCaption",
                            display: "Notified Date",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: true,
                            field: "WarningBanner",
                            display: "The assessment day is stated in the Contract Data. There is an assessment day in each month from the starting date until the month after the Defects Certificate has been issued",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: true,
                            field: "LessAmountsDueLabel",
                            display: "Less amount due as previously notified by the Contractor",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 8,
                            isActive: true,
                            field: "RegisterAppliedByCaption",
                            display: "Submitted by",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 9,
                            isActive: true,
                            field: "SummaryDetailsLabel",
                            display: "Summary details",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "TaxEnabled",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "TaxEnabled",
                            display: "Active-Inactive state indicates tax field will be included in notification forms",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "PaymentTypes",
                    values: [
                        {
                            id: 2,
                            isActive: true,
                            field: "INTERIM",
                            display: "51.1 payment certificate within three weeks of assessment date",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: false,
                            field: "COMPLETION",
                            display: "Completion",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 1,
                            isActive: false,
                            field: "FINAL",
                            display: "53.1 final payment certificate",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: false,
                            field: "SUPPLEMENTARY",
                            display: "Supplementary",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: false,
                            field: "DRAFT",
                            display: "Draft",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: false,
                            field: "EXTRA",
                            display: "Extra",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: false,
                            field: "OTHER",
                            display: "Other",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "ApplicationTypes",
                    values: [
                        {
                            id: 2,
                            isActive: true,
                            field: "INTERIM",
                            display: "50.1 application for payment",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: false,
                            field: "COMPLETION",
                            display: "Completion",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 1,
                            isActive: false,
                            field: "FINAL",
                            display: "53.2 assessment of the final amount due",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 8,
                            isActive: false,
                            field: "TERMINATION",
                            display: "Termination",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: false,
                            field: "SUPPLEMENTARY",
                            display: "Supplementary",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: false,
                            field: "DRAFT",
                            display: "Draft",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: false,
                            field: "EXTRA",
                            display: "Extra",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: false,
                            field: "OTHER",
                            display: "Other",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                }
            ]
        },
        {
            id: 117,
            title: "Other Certificates",
            workflows: [
                {
                    id: 68,
                    title: "$PM_NAME Certificates",
                    notificationName: "Certificate",
                    abbreviation: "$PM_ABBREVIATION-Certificate-",
                    notify: true,
                    replyEnabled: false,
                    assetFieldsEnabled: false,
                    replyPeriodOption: "SUPPLIER_REPLY_PERIOD",
                    replyPeriod: 0,
                    resubmitPeriodOption: "PM_REPLY_PERIOD",
                    resubmitPeriod: 0,
                    notifyingParty: "PM",
                    replyingParty: "SUPPLIER",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    replyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
                            communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        replyNotice: {
                            saveDraftReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Cost Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            communicateReplyFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]"
                    }
                }
            ],
            placeholders: [
                {
                    replacementKey: "Resources",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "PmCertificateText",
                            display: "",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "SupplierCertificateText",
                            display: "",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "ClientCertificateText",
                            display: "",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "SupervisorCertificateText",
                            display: "",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "CompletionFields",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "CertifiedDate",
                            display: "Completion Date",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "Description",
                            display: "Details",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "Works",
                            display: "Outstanding Works",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "Defects",
                            display: "Defects",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "SectionalCompletionFields",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "CertifiedDate",
                            display: "Sectional Completion Date",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "Description",
                            display: "Details",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "Works",
                            display: "Outstanding Works",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "Defects",
                            display: "Defects",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "TakingOverFields",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "CertifiedDate",
                            display: "Taking Over Date",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "Description",
                            display: "Details",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "Works",
                            display: "Outstanding Works",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "Defects",
                            display: "Defects",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "DefectsFields",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "CertifiedDate",
                            display: "Certified Date",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "Description",
                            display: "Details",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: false,
                            field: "Works",
                            display: "Outstanding Works",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "Defects",
                            display: "Outstanding Defects",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "TerminationFields",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "CertifiedDate",
                            display: "Certified Date",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "Description",
                            display: "Details",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: false,
                            field: "Works",
                            display: "Outstanding Works",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: false,
                            field: "Defects",
                            display: "Outstanding Defects",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "OtherFields",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "CertifiedDate",
                            display: "Certified Date",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "Description",
                            display: "Details",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: false,
                            field: "Works",
                            display: "Outstanding Works",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: false,
                            field: "Defects",
                            display: "Outstanding Defects",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "TaskOrderCompletionFields",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "CertifiedDate",
                            display: "Certified Date",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "Description",
                            display: "Details",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: false,
                            field: "Works",
                            display: "Outstanding Works",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: false,
                            field: "Defects",
                            display: "Outstanding Defects",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "ProjectOrderCompletionFields",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "CertifiedDate",
                            display: "Certified Date",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "Description",
                            display: "Details",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: false,
                            field: "Works",
                            display: "Outstanding Works",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: false,
                            field: "Defects",
                            display: "Outstanding Defects",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "ReplyOptions",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "Accepted",
                            display: "Accepted",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "Not Accepted",
                            display: "Not Accepted",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "PMCertTypes",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "",
                            display: "30.2 Completion Certificate",
                            effect: "COMPLETION",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: false,
                            field: "",
                            display: "X5 30.2 Sectional Completion Certificate",
                            effect: "SECTIONAL_COMPLETION",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: false,
                            field: "",
                            display: "35.3 Taking Over Certificate",
                            effect: "TAKING_OVER",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 9,
                            isActive: false,
                            field: "",
                            display: "43.3 Defects Certificate (NEC3 ECC)",
                            effect: "DEFECTS",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: false,
                            field: "",
                            display: "44.3 Defects Certificate",
                            effect: "DEFECTS",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: true,
                            field: "",
                            display: "90.1 Termination Certificate",
                            effect: "TERMINATION",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 10,
                            isActive: false,
                            field: "",
                            display: "X19.1 Termination Certificate (NEC4 TSC)",
                            effect: "TERMINATION",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: false,
                            field: "",
                            display: "Other Certificate",
                            effect: "OTHER",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: false,
                            field: "",
                            display: "Task Order Completion",
                            effect: "TASK_ORDER_COMPLETION",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 8,
                            isActive: false,
                            field: "",
                            display: "Project Order Completion",
                            effect: "PROJECT_ORDER_COMPLETION",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "SupplierCertTypes",
                    values: [
                        {
                            id: 1,
                            isActive: false,
                            field: "",
                            display: "Completion Certificate",
                            effect: "COMPLETION",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: false,
                            field: "",
                            display: "Sectional Completion Certificate",
                            effect: "SECTIONAL_COMPLETION",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: false,
                            field: "",
                            display: "Taking Over Certificate",
                            effect: "TAKING_OVER",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: false,
                            field: "",
                            display: "Defects Certificate",
                            effect: "DEFECTS",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: false,
                            field: "",
                            display: "Termination Certificate",
                            effect: "TERMINATION",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: true,
                            field: "",
                            display: "Other Certificate",
                            effect: "OTHER",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: false,
                            field: "",
                            display: "Task Order Completion",
                            effect: "TASK_ORDER_COMPLETION",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 8,
                            isActive: false,
                            field: "",
                            display: "Project Order Completion",
                            effect: "PROJECT_ORDER_COMPLETION",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "ClientCertTypes",
                    values: [
                        {
                            id: 1,
                            isActive: false,
                            field: "",
                            display: "Completion Certificate",
                            effect: "COMPLETION",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: false,
                            field: "",
                            display: "Sectional Completion Certificate",
                            effect: "SECTIONAL_COMPLETION",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: false,
                            field: "",
                            display: "Taking Over Certificate",
                            effect: "TAKING_OVER",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: false,
                            field: "",
                            display: "Defects Certificate",
                            effect: "DEFECTS",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: true,
                            field: "",
                            display: "Termination Certificate",
                            effect: "TERMINATION",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: true,
                            field: "",
                            display: "Other Certificate",
                            effect: "OTHER",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: false,
                            field: "",
                            display: "Task Order Completion",
                            effect: "TASK_ORDER_COMPLETION",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 8,
                            isActive: false,
                            field: "",
                            display: "Project Order Completion",
                            effect: "PROJECT_ORDER_COMPLETION",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "SupervisorCertTypes",
                    values: [
                        {
                            id: 1,
                            isActive: false,
                            field: "",
                            display: "Completion Certificate",
                            effect: "COMPLETION",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: false,
                            field: "",
                            display: "Sectional Completion Certificate",
                            effect: "SECTIONAL_COMPLETION",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: false,
                            field: "",
                            display: "Taking Over Certificate",
                            effect: "TAKING_OVER",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: false,
                            field: "",
                            display: "43.3 Defects Certificate (NEC3 ECC)",
                            effect: "DEFECTS",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 9,
                            isActive: true,
                            field: "",
                            display: "44.3 Defects Certificate",
                            effect: "DEFECTS",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: false,
                            field: "",
                            display: "Termination Certificate",
                            effect: "TERMINATION",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: false,
                            field: "",
                            display: "Other Certificate",
                            effect: "OTHER",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: false,
                            field: "",
                            display: "Task Order Completion",
                            effect: "TASK_ORDER_COMPLETION",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 8,
                            isActive: false,
                            field: "",
                            display: "Project Order Completion",
                            effect: "PROJECT_ORDER_COMPLETION",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "CompletionChangesStateEnabled",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "CompletionChangesStateEnabled",
                            display: "Indicate whether communication of a Completion Certificate should change the contract state",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "ActionReminders",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "PM",
                            display: "$WF_68_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "Supplier",
                            display: "$WF_69_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "Client",
                            display: "$WF_70_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "Supervisor",
                            display: "$WF_71_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                }
            ]
        },
        {
            id: 109,
            title: "Defects",
            workflows: [
                {
                    id: 22,
                    title: "Instruction to Search",
                    notificationName: "Instruction to Search",
                    pageTitle: "$PM_NAME Instruction to Search",
                    abbreviation: "Search-",
                    notify: true,
                    replyEnabled: true,
                    assetFieldsEnabled: false,
                    replyPeriodOption: "NOTIFICATION_DATE",
                    replyPeriod: 0,
                    notifyingParty: "PM",
                    replyingParty: "PM",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    replyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
                            communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        replyNotice: {
                            saveDraftReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Support\"],\"or\",[\"rolepermissions\",\"=\",\"Manager\"]]]",
                            communicateReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]"
                    }
                },
                {
                    id: 23,
                    title: "$PM_NAME Defect Notifications",
                    notificationName: "Defect Notification",
                    pageTitle: "$PM_NAME Defect Notification",
                    abbreviation: "$PM_NAME-Defect-",
                    notify: true,
                    assetFieldsEnabled: false,
                    notifyingParty: "PM",
                    actioningParty: "PM",
                    resolveActioningParty: "PM",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
                            communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        actionTab: {
                            actionFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Client\"],\"or\",[\"party\",\"=\",\"Supervisor\"]]",
                        resolveActionTab: {
                            resolveActionFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]"
                        }
                    }
                }
            ],
            placeholders: [
                {
                    replacementKey: "Resources",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "InstructionClauseLabel",
                            display: "You are instructed to search for a Defect as follows",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "SupervisorClauseLabel",
                            display: "You are notified of the following Defect",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "SupplierClauseLabel",
                            display: "You are instructed under clause 41.3 with Details",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "TestsClauseLabel",
                            display: "You are instructed under clause 41.3 with Details",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "UnifiedClauses",
                    values: [
                        {
                            id: 3,
                            wfid: 22,
                            isActive: true,
                            field: "",
                            display: "40.1 Instruction to search for a Defect",
                            overrideResources: null,
                            postActions: [
                                {
                                    askUser: false,
                                    daysForAction: 0,
                                    action: "CREATE",
                                    ownerParty: "SUPPLIER",
                                    actionType: "WF_24",
                                    timePeriod: "SUPPLIER_REPLY_PERIOD"
                                }
                            ]
                        },
                        {
                            id: 1,
                            wfid: 23,
                            isActive: true,
                            field: "",
                            display: "40.2 Notification of a Defect",
                            overrideResources: null,
                            postActions: []
                        },
                        {
                            id: 2,
                            wfid: 24,
                            isActive: true,
                            field: "",
                            display: "40.2 Notification of a Defect",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "ActionReminders",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "Instruction",
                            display: "$WF_22_TITLE awaiting closure",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "SuperDefect",
                            display: "$WF_23_TITLE awaiting closure",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 8,
                            isActive: true,
                            field: "SupplierDefect",
                            display: "$WF_24_TITLE awaiting closure",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "Inspection",
                            display: "$WF_25_TITLE awaiting closure",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 4,
                            isActive: true,
                            field: "SupervisorTestAndInspection",
                            display: "$WF_47_TITLE awaiting closure",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 5,
                            isActive: true,
                            field: "PMTestAndInspection",
                            display: "$WF_48_TITLE awaiting closure",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 6,
                            isActive: true,
                            field: "PMNCProposal",
                            display: "$WF_54_TITLE awaiting acceptance",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 7,
                            isActive: true,
                            field: "NonConformity",
                            display: "$WF_55_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                },
                {
                    replacementKey: "ClosureReasonOptions",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "Accepted",
                            display: "Accepted",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "Corrected",
                            display: "Corrected",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 3,
                            isActive: true,
                            field: "No Defect",
                            display: "Not a Defect",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                }
            ]
        },
        {
            id: 110,
            title: "Delegated Actions",
            workflows: [
                {
                    id: 27,
                    title: "$PM_NAME Delegated Actions",
                    notificationName: "Delegated Action",
                    abbreviation: "$PM_ABBREVIATION-Action-",
                    notify: true,
                    assetFieldsEnabled: false,
                    notifyingParty: "PM",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
                            communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Supervisor\"],\"or\",[\"party\",\"=\",\"Client\"]]"
                    }
                }
            ],
            placeholders: [
                {
                    replacementKey: "Resources",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "DelegationClause",
                            display: "You are notified that the following specific powers",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                }
            ]
        },
        {
            id: 111,
            title: "Records",
            workflows: [
                {
                    id: 30,
                    title: "$PM_NAME Meetings",
                    notificationName: "Meeting",
                    abbreviation: "$PM_ABBREVIATION-Meeting-",
                    notify: true,
                    assetFieldsEnabled: false,
                    notifyingParty: "PM",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"PM\"]",
                            communicateFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Supervisor\"],\"or\",[\"party\",\"=\",\"Client\"]]"
                    }
                },
                {
                    id: 31,
                    title: "$SUPPLIER_NAME Meetings",
                    notificationName: "Meeting",
                    abbreviation: "$SUPPLIER_ABBREVIATION-Meeting-",
                    notify: true,
                    assetFieldsEnabled: false,
                    notifyingParty: "SUPPLIER",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
                            communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Supervisor\"],\"or\",[\"party\",\"=\",\"Client\"]]"
                    }
                },
                {
                    id: 32,
                    title: "$SUPPLIER_NAME Site Diary",
                    notificationName: "Site Diary",
                    abbreviation: "Diary-",
                    notify: true,
                    assetFieldsEnabled: false,
                    notifyingParty: "SUPPLIER",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
                            communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Supervisor\"],\"or\",[\"party\",\"=\",\"Client\"]]"
                    }
                },
                {
                    id: 33,
                    title: "Weather",
                    notificationName: "Weather",
                    abbreviation: "Weather-",
                    notify: true,
                    assetFieldsEnabled: false,
                    notifyingParty: "SUPPLIER",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
                            communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"Supervisor\"],\"or\",[\"party\",\"=\",\"Client\"]]"
                    }
                }
            ],
            placeholders: []
        },
        {
            id: 112,
            title: "RFI / TQ",
            workflows: [
                {
                    id: 34,
                    title: "$SUPPLIER_NAME RFI / TQ",
                    notificationName: "RFI / TQ",
                    abbreviation: "RFI/TQ-",
                    notify: true,
                    replyEnabled: true,
                    assetFieldsEnabled: false,
                    replyPeriodOption: "ASKED_ON_COMMUNICATION_FORM",
                    replyPeriod: 0,
                    notifyingParty: "SUPPLIER",
                    replyingParty: "PM",
                    form_IncludeCompanyName: true,
                    form_CompanyLogo: "PARTY",
                    form_CompanyName: "PARTY",
                    notifyAttachments: true,
                    replyAttachments: true,
                    includePdfjson: false,
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        mainNotice: {
                            createFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            viewDraftFilter: "[\"party\",\"=\",\"Contractor\"]",
                            communicateFilter: "[[\"party\",\"=\",\"Contractor\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        },
                        replyNotice: {
                            saveDraftReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]",
                            communicateReplyFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[[\"rolepermissions\",\"=\",\"Manager\"],\"or\",[\"rolepermissions\",\"=\",\"Support\"]]]"
                        },
                        notifyFilter: "[[\"party\",\"=\",\"Contractor\"],\"or\",[\"party\",\"=\",\"PM\"],\"or\",[\"party\",\"=\",\"Supervisor\"],\"or\",[\"party\",\"=\",\"Client\"]]"
                    }
                }
            ],
            placeholders: [
                {
                    replacementKey: "ActionReminders",
                    values: [
                        {
                            id: 1,
                            isActive: true,
                            field: "Supplier",
                            display: "$WF_34_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        },
                        {
                            id: 2,
                            isActive: true,
                            field: "PM",
                            display: "$WF_80_TITLE awaiting reply",
                            overrideResources: null,
                            postActions: null
                        }
                    ]
                }
            ]
        },
        {
            id: 113,
            title: "Contract Information",
            workflows: [
                {
                    id: 39,
                    title: "Documents",
                    notificationName: "Document",
                    abbreviation: "Documents-",
                    actioningParty: "PM",
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        actionTab: {
                            actionFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        }
                    }
                },
                {
                    id: 44,
                    title: "Project Bank Accounts",
                    notificationName: "Project Bank Account",
                    abbreviation: "BankAccount-",
                    actioningParty: "PM",
                    overrideResources: null,
                    userFilters: {
                        accessFilter: "null",
                        actionTab: {
                            actionFilter: "[[\"party\",\"=\",\"PM\"],\"and\",[\"rolepermissions\",\"=\",\"Manager\"]]"
                        }
                    }
                }
            ],
            placeholders: [
                {
                    replacementKey: "Resources",
                    values: []
                },
                {
                    replacementKey: "ActionReminders",
                    values: []
                }
            ]
        }
    ]
};
export default template;